import { gql } from '@apollo/client';

// Supprimez ou commentez ce log qui semble bloquer l'exécution

export const GET_CLIENTS = gql`
  query GetClients($agencyId: Int, $agencyName: String) {
    clients(agencyId: $agencyId, agencyName: $agencyName) {
      id
      firstName
      lastName
      email
      phone
      address
      createdAt
      agency {
        id
        name
      }
    }
  }
`;

export const GET_AGENCY_BY_NAME = gql`
  query GetAgencyByName($name: String!) {
    agency(name: $name) {
      id
      name
    }
  }
`;

export const GET_CLIENT = gql`
  query GetClient($id: Int!) {
    client(id: $id) {
      id
      firstName
      lastName
      email
      phone
      address
      isActive
      agencyId
      agency {
        id
        name
      }
      packageClients {
        id
        packageId
        package {
          id
          title
          image
        }
      }
    }
  }
`;

export const CREATE_CLIENT = gql`
  mutation CreateClient($input: ClientInput!) {
    createClient(input: $input) {
      id
      firstName
      lastName
      email
      phone
      address
      isActive
      agencyId
      createdAt
      updatedAt
      agency {
        id
        name
      }
    }
  }
`;

export const GET_ALL_CLIENTS = gql`
  query GetAllClients {
    allClients {
      id
      firstName
      lastName
      email
      phone
      address
      createdAt
      agency {
        id
        name
      }
    }
  }
`;

export const GET_MY_AGENCY_CLIENTS = gql`
  query GetMyAgencyClients {
    myAgencyClients {
      id
      firstName
      lastName
      email
      phone
      address
      createdAt
      agency {
        id
        name
      }
    }
  }
`;

export const GET_AGENCY_CLIENTS = gql`
  query GetAgencyClients($agencyId: Int!) {
    clients(agencyId: $agencyId) {
      id
      firstName
      lastName
      email
      phone
      address
      passport
      isActive
      agencyId
      createdAt
      updatedAt
      agency {
        id
        name
      }
      packages {
        id
        packageId
      }
    }
  }
`; 